import type { Dispatch, SetStateAction } from 'react';
import type { IFormApiError, IInitialFormValues, TFormType } from '../types';

const handleErrors = (errors: IFormApiError, setErrors: Dispatch<SetStateAction<string[]>>, setFieldError: (field: string, value: string | undefined) => void, values: IInitialFormValues, form: TFormType) => {
  const apiErrors = Object.entries(errors);
  if (apiErrors.length > 0) {
    const fieldNames = Object.keys(values);
    const formErrors: string[] = [];
    apiErrors.forEach(([key, value]) => {
      window?.heap?.track?.('Marketing Form Error', {
        emailAddress: values?.email ?? '',
        field: key,
        formName: form,
        host: process.env.GATSBY_HOST ?? '',
        message: value[0] ?? '',
      });
      if (key === '__all__') {
        formErrors.push(value[0]);
      } else if (fieldNames.includes(key)) {
        setFieldError(key, value[0]);
      } else {
        formErrors.push(`There was an issue processing your request. Please contact support. Ref: ${btoa([key, value].join())}`);
      }
    });
    setErrors(formErrors);
  }
};

export default handleErrors;
